"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _superagent2 = _interopRequireDefault(require("superagent"));
var _getSearchUrl = _interopRequireDefault(require("../getSearchUrl"));
var sendProductSearchRequest = function sendProductSearchRequest(_ref) {
  var query = _ref.query,
    currentPage = _ref.currentPage,
    pageSize = _ref.pageSize,
    categoryId = _ref.categoryId,
    lang = _ref.lang,
    pickedFilters = _ref.pickedFilters;
  return _superagent2["default"].get((0, _getSearchUrl["default"])({
    url: "/products",
    query: query,
    currentPage: currentPage,
    pageSize: pageSize,
    pickedFilters: pickedFilters,
    categoryId: categoryId,
    lang: lang
  })).withCredentials().then(function (res) {
    return res.body;
  });
};
var _default = sendProductSearchRequest;
exports["default"] = _default;